import React, { useCallback } from 'react';

import Dropdown from '@prisjakt/ui-dropdown';
import DotsIcon from 'mdi-react/DotsVerticalIcon';

import { Option, Review } from './types';

import * as S from './styles';

type Props = {
  actions: {
    name: string;
    handler: (review: Review) => void;
  }[];
  id: string;
};

const ReviewActions = ({ actions, id }: Props) => {
  const onSelect = useCallback(
    (option: Option) => {
      if (typeof actions[option.value].handler === 'function') {
        actions[option.value].handler({ id });
      }
    },
    [actions, id]
  );

  return (
    <S.Actions>
      <Dropdown
        title={<DotsIcon />}
        type="select-box-independent-type"
        headerPosition="right"
        offsetOrigin="right"
        options={actions.map(
          (item, index) =>
            ({
              name: item.name,
              value: `${index}`,
            } as Option)
        )}
        onSelect={onSelect}
      />
    </S.Actions>
  );
};

export default ReviewActions;
